<template>
  <div>
    <parsed-panel v-if="data" :data="data"/>
    <div v-if="!data">{{ hint }}</div>
  </div>
</template>

<script>
import ParsedPanel from './ParsedPanel.vue'
import { parse } from '@/services/ShcService'

export default {
  components: {
    ParsedPanel
  },
  data () {
    return {
      data: null,
      hint: 'loading...'
    }
  },
  mounted: async function () {
    try {
      const objId = this.$route.query.objId
      const res = await parse(objId, 0)
      console.log(res.data)
      if (res.data.result) {
        this.data = res.data.result
      } else {
        this.hint = 'no data!'
      }
    } catch (err) {
      console.error(err)
      this.hint = 'no data!'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ParseShc.vue